const boatsObject = {
    carrier: {
        name: "Carrier",
        length: 5
    },
    battleship: {
        name: "Battleship",
        length: 4
    },
    cruiser: {
        name: "Cruiser",
        length: 3
    },
    submarine: {
        name: "Submarine",
        length: 3
    },
    destroyer: {
        name: "Destroyer",
        length: 2
    },

}

module.exports = boatsObject